<template>
    <evp-layout>
        <navigation-header
            :return-url="route('home')"
            :title="$t('sos.SosTitle')"
        />

        <div class="hidden xl:block h-[301px] mb-0.5 bg-contain bg-no-repeat bg-[url(@/images/title-banner/sos.png)]"></div>

        <div class="px-11 pt-7 pb-9">
            {{ $t('sos.SosText') }}
        </div>

        <div class="flex flex-col md:flex-row items-stretch mx-4 lg:mx-0">

            <div class="bg-surface shadow-small px-11 py-6 w-full mb-6 md:mr-6 rounded-md">
                <h2 class="text-xl text-[#de350b]">{{ $t('sos.EmergencyNumberTitle') }}</h2>

                <p class="mt-5">{{ $t('sos.EmergencyNumber1Title') }}:</p>
                <a href="tel:113" class="button-emergency my-1">113</a>
                <a 
                    href="http://www.nmpd.gov.lv/nmpd/kad_saukt_NMP/"
                    class="link-primary"
                    target="_blank"
                    rel="external noopener"
                >
                    {{ $t('sos.EmergencyNumber1aTitle') }}
                </a>


                <p class="mt-8">{{ $t('sos.EmergencyNumber2Title') }}:</p>
                <a href="tel:112" class="button-emergency my-1">112</a>
                <a
                    href="https://www.vugd.gov.lv/lv/pakalpojumi/vienotais-arkartas-palidzibas-izsaukuma-numurs-112"
                    class="link-primary"
                    target="_blank"
                    rel="external noopener"
                >
                    {{ $t('sos.EmergencyNumber2aTitle') }}
                </a>
            </div>

            <div class="bg-surface shadow-small px-11 py-6 w-full mb-6 rounded-md">
                <h2 class="text-xl">{{ $t('sos.OtherEmergencyNumberTitle') }}:</h2>

                <p class="mt-4">{{ $t('sos.OtherEmergencyNumber1Title') }}:</p>

                <div class="border-2 border-solid border-neutral-500 text-gray-500 flex items-center justify-center h-9 my-1">
                    {{ $t('sos.OtherEmergencyNumber1bTitle') }}
                </div>

                <a
                    href="https://www.vmnvd.gov.lv/lv/gimenes-arsti"
                    class="link-primary"
                    target="_blank"
                    rel="external noopener"
                >
                    {{ $t('sos.OtherEmergencyNumber1aTitle') }}
                </a>

                <p class="mt-6">{{ $t('sos.OtherEmergencyNumber2Title') }}:</p>
                <a href="tel:+37166016001" class="button-primary h-9 my-1">66016001</a>
                <a
                    href="https://www.nmpd.gov.lv/lv/kad-zvanit-gimenes-arstu-konsultativajam-talrunim"
                    class="link-primary"
                    target="_blank"
                    rel="external noopener"
                >
                    {{ $t('sos.OtherEmergencyNumber2aTitle') }}
                </a>
            </div>

        </div>

        <div class="flex flex-col md:flex-row items-stretch mx-4 lg:mx-0">
            <div class="bg-surface shadow-small px-11 py-6 w-full md:mr-6 mb-6 rounded-md">
                <h2 class="text-xl">{{ $t('sos.CovidTitle') }}:</h2>
                <p class="mt-6">{{ $t('sos.Covid1Title') }}:</p>
                <a href="tel:+37167387661" class="button-primary h-9 my-1">67387661</a>
            </div>

            <div class="bg-surface shadow-small px-11 py-6 w-full md:mr-6 mb-6 rounded-md">
                <h2 class="text-xl">{{ $t('sos.CrisisTitle') }}:</h2>
                <p class="mt-6">{{ $t('sos.Crisis1Title') }}</p>
                <a href="tel:116123" class="button-primary h-9 mt-1 mb-2">116123</a>
                <a href="tel:+37167222922" class="button-primary h-9 mb-2">67222922</a>
                <a href="tel:+37127722292" class="button-primary h-9 mb-2">27722292</a>
                <a
                    href="https://www.skalbes.lv/sanem-palidzibu/"
                    class="link-primary"
                    target="_blank"
                    rel="external noopener"
                >
                    {{ $t('sos.Crisis1aTitle') }}
                </a>
            </div>

            <div class="bg-surface shadow-small px-11 py-6 w-full mb-6 rounded-md">
                <h2 class="text-xl mb-6">{{ $t('sos.ChildrenSupportTitle') }}:</h2>
                <a href="tel:116111" class="button-primary h-9 my-1">116111</a>
                <a
                    href="http://www.bti.gov.lv/lat/uzticibas_talrunis/"
                    class="link-primary"
                    target="_blank"
                    rel="external noopener"
                >
                    {{ $t('sos.ChildrenSupport1aTitle') }}
                </a>
            </div>
        </div>
    </evp-layout>
</template>

<script setup>
    import EvpLayout from '@/components/EvpLayout.vue'
    import { route } from 'ziggy'
    import NavigationHeader from '@/components/NavigationHeader.vue'
</script>